<template>
    <div class="row wrap">
        <div class="col-6">
            <input-text v-model="label.x_coord" :label="$t('Coord X')" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.y_coord" :label="$t('Coord Y')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <input-media v-model="label.image" :label="$t('Image')" :storie-id="label.getStoryId()" @change="label.save()" required/>
        </div>
        <div class="col-6">
            <input-text v-model="label.width" :label="$t('Width')" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.height" :label="$t('Height')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <input-select :label="$t('Effect')" :items="[{text:$t('Wave'),value:'wave'}, {text:$t('Static'),value:'static'}]" v-model="label.effect" @change="label.save()" :placeholder="$t('Effect')"/>
        </div>
        <div class="col-12">
            <Pointer_Edit :label="label"/>
        </div>
    </div>
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import Pointer_Edit from "@/modules/labels/Pointer_Edit";
    import {label} from "@/class/label";
    import InputMedia from "@/modules/input/input-media";
    import InputSelect from "@/modules/input/input-select";

    export default {
        name: "Overlays_Edit",
        components: {InputSelect, InputMedia, Pointer_Edit, InputText},
        props:{
            label:{type:Object,default:() => new label()}
        },
        methods:{
            getSizeImage(){
                let img = new Image;
                img.src = this.label.image.media;
                console.log("ok")

                // On loaded, show lables and stop loaders
                img.addEventListener("load", () => {
                    this.label.width = img.width;
                    this.label.height = img.height;
                    this.$emit('update', this.label)
                })
            },
        },
        watch:{
            'label.image'(val,prev){
                if(val.id === prev.id) return;
                this.getSizeImage();
            }
        },
    }
</script>